var _path, _path2, _rect, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgMetamaskConnect = function SvgMetamaskConnect(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 152,
    viewBox: "0 0 142 152",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M141.695 85.1698H0.353516L18.4049 72.5234H123.644L141.695 85.1698Z",
    fill: "url(#paint0_linear_2746_11494)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M142 84.9844H0L17.5632 151.984H122.568L142 84.9844Z",
    fill: "url(#paint1_linear_2746_11494)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2746_11494",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 72,
    width: 71,
    height: 14
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 34.0605,
    y: 72.5215,
    width: 70.6707,
    height: 12.6463,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2746_11494)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2746_11494)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 69.0234,
    cy: 72.8922,
    rx: 24.5488,
    ry: 4.09146,
    fill: "#160438"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0062 7.6875L74.4629 23.688L78.4468 14.2479L96.0062 7.6875Z",
    fill: "#E2761B",
    stroke: "#E2761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2715 7.6875L67.6416 23.8396L63.8526 14.2479L46.2715 7.6875Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2543 44.7773L82.5166 53.5679L94.793 56.9455L98.3222 44.9722L88.2543 44.7773Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.998 44.9703L47.5056 56.9436L59.782 53.5659L54.0444 44.7754L43.998 44.9703Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0889 29.9242L55.668 35.0989L67.8578 35.6402L67.4248 22.541L59.0889 29.9242Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1865 29.9234L74.7424 22.3887L74.4609 35.6394L86.6291 35.0981L83.1865 29.9234Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7822 53.5676L67.1005 49.9951L60.7782 45.0586L59.7822 53.5676Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1768 49.9951L82.5166 53.5676L81.499 45.0586L75.1768 49.9951Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5176 53.5647L75.1777 49.9922L75.7623 54.7772L75.6974 56.7908L82.5176 53.5647Z",
    fill: "#D7C1B3",
    stroke: "#D7C1B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7832 53.5647L66.6034 56.7908L66.5601 54.7772L67.1014 49.9922L59.7832 53.5647Z",
    fill: "#D7C1B3",
    stroke: "#D7C1B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7112 41.8962L60.6055 40.0992L64.9141 38.1289L66.7112 41.8962Z",
    fill: "#233447",
    stroke: "#233447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5664 41.8962L77.3635 38.1289L81.6938 40.0992L75.5664 41.8962Z",
    fill: "#233447",
    stroke: "#233447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7826 53.5659L60.8219 44.7754L54.0449 44.9703L59.7826 53.5659Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4785 44.7754L82.5178 53.5659L88.2555 44.9703L81.4785 44.7754Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M86.631 35.0977L74.4629 35.6389L75.5888 41.8962L77.3858 38.1289L81.7161 40.0992L86.631 35.0977Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6065 40.0992L64.9368 38.1289L66.7122 41.8962L67.8598 35.6389L55.6699 35.0977L60.6065 40.0992Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6699 35.0977L60.7797 45.0574L60.6065 40.0992L55.6699 35.0977Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7175 40.0992L81.501 45.0574L86.6324 35.0977L81.7175 40.0992Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8604 35.6387L66.7129 41.896L68.1419 49.2792L68.4667 39.5576L67.8604 35.6387Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4635 35.6387L73.8789 39.536L74.1387 49.2792L75.5894 41.896L74.4635 35.6387Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5883 41.8947L74.1377 49.2779L75.177 49.9925L81.4992 45.0559L81.7157 40.0977L75.5883 41.8947Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6055 40.0977L60.7787 45.0559L67.1009 49.9925L68.1402 49.278L66.7112 41.8947L60.6055 40.0977Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6971 56.7925L75.7621 54.7789L75.2208 54.3026H67.0581L66.5601 54.7789L66.6034 56.7925L59.7832 53.5664L62.1649 55.5151L66.9932 58.8711H75.2857L80.1357 55.5151L82.5173 53.5664L75.6971 56.7925Z",
    fill: "#C0AD9E",
    stroke: "#C0AD9E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1779 49.9938L74.1386 49.2793H68.1411L67.1018 49.9938L66.5605 54.7788L67.0585 54.3025H75.2212L75.7625 54.7788L75.1779 49.9938Z",
    fill: "#161616",
    stroke: "#161616",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9159 24.7273L98.7563 15.8934L96.0065 7.6875L75.1777 23.1467L83.1888 29.9237L94.5126 33.2364L97.0242 30.3134L95.9416 29.5339L97.6737 27.9534L96.3313 26.9141L98.0634 25.5933L96.9159 24.7273Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5449 15.8934L45.3853 24.7273L44.2161 25.5933L45.9482 26.9141L44.6275 27.9534L46.3596 29.5339L45.277 30.3134L47.767 33.2364L59.0908 29.9237L67.1019 23.1467L46.273 7.6875L43.5449 15.8934Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5116 33.2346L83.1878 29.9219L86.6304 35.0966L81.499 45.0563L88.2543 44.9697H98.3223L94.5116 33.2346Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0892 29.9219L47.7654 33.2346L43.998 44.9697H54.0444L60.778 45.0563L55.6682 35.0966L59.0892 29.9219Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4628 35.6378L75.1773 23.1449L78.4683 14.2461H63.8535L67.1012 23.1449L67.8591 35.6378L68.1189 39.5784L68.1405 49.2783H74.138L74.1813 39.5784L74.4628 35.6378Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8634 144H46.7104V137.774L49.5154 141.888H49.5594L52.3644 137.763V144H53.2334V136.3H52.3534L49.5484 140.502L46.7434 136.3H45.8634V144ZM57.7562 144.132C58.8342 144.132 59.5272 143.703 60.0992 143.065L59.5712 142.592C59.1092 143.076 58.5592 143.395 57.7782 143.395C56.7662 143.395 55.8972 142.702 55.7762 141.47H60.2862C60.2972 141.371 60.2972 141.305 60.2972 141.195C60.2972 139.534 59.3292 138.192 57.6462 138.192C56.0732 138.192 54.9182 139.512 54.9182 141.151V141.173C54.9182 142.933 56.1942 144.132 57.7562 144.132ZM55.7762 140.843C55.8862 139.732 56.6342 138.907 57.6242 138.907C58.7572 138.907 59.3512 139.809 59.4392 140.843H55.7762ZM63.683 144.099C64.09 144.099 64.409 144.011 64.706 143.857V143.131C64.409 143.274 64.167 143.329 63.881 143.329C63.309 143.329 62.924 143.076 62.924 142.383V139.061H64.728V138.313H62.924V136.597H62.077V138.313H61.285V139.061H62.077V142.493C62.077 143.648 62.77 144.099 63.683 144.099ZM67.9212 144.121C68.9222 144.121 69.5822 143.659 69.9782 143.142V144H70.7922V140.524C70.7922 139.798 70.5942 139.248 70.2092 138.863C69.7912 138.445 69.1752 138.236 68.3722 138.236C67.5472 138.236 66.9312 138.423 66.3042 138.709L66.5572 139.402C67.0852 139.16 67.6132 138.984 68.2842 138.984C69.3512 138.984 69.9782 139.512 69.9782 140.535V140.733C69.4722 140.59 68.9552 140.491 68.2292 140.491C66.7882 140.491 65.7982 141.129 65.7982 142.328V142.35C65.7982 143.516 66.8652 144.121 67.9212 144.121ZM68.0862 143.45C67.3162 143.45 66.6562 143.032 66.6562 142.317V142.295C66.6562 141.58 67.2502 141.118 68.3172 141.118C69.0102 141.118 69.5712 141.239 69.9892 141.36V141.91C69.9892 142.812 69.1312 143.45 68.0862 143.45ZM72.5973 144H73.4443V140.755C73.4443 139.71 74.1263 138.962 75.0283 138.962C75.9303 138.962 76.4913 139.589 76.4913 140.656V144H77.3383V140.722C77.3383 139.6 78.0423 138.962 78.9003 138.962C79.8243 138.962 80.3743 139.578 80.3743 140.678V144H81.2213V140.48C81.2213 139.072 80.4183 138.192 79.1093 138.192C78.1193 138.192 77.5143 138.698 77.1073 139.325C76.7993 138.687 76.2053 138.192 75.2813 138.192C74.3243 138.192 73.8183 138.709 73.4443 139.27V138.313H72.5973V144ZM84.7542 144.121C85.7552 144.121 86.4152 143.659 86.8112 143.142V144H87.6252V140.524C87.6252 139.798 87.4272 139.248 87.0422 138.863C86.6242 138.445 86.0082 138.236 85.2052 138.236C84.3802 138.236 83.7642 138.423 83.1372 138.709L83.3902 139.402C83.9182 139.16 84.4462 138.984 85.1172 138.984C86.1842 138.984 86.8112 139.512 86.8112 140.535V140.733C86.3052 140.59 85.7882 140.491 85.0622 140.491C83.6212 140.491 82.6312 141.129 82.6312 142.328V142.35C82.6312 143.516 83.6982 144.121 84.7542 144.121ZM84.9192 143.45C84.1492 143.45 83.4892 143.032 83.4892 142.317V142.295C83.4892 141.58 84.0832 141.118 85.1502 141.118C85.8432 141.118 86.4042 141.239 86.8222 141.36V141.91C86.8222 142.812 85.9642 143.45 84.9192 143.45ZM91.3113 144.11C92.4443 144.11 93.3353 143.483 93.3353 142.405V142.383C93.3353 141.36 92.3893 141.019 91.5093 140.755C90.7503 140.524 90.0463 140.315 90.0463 139.776V139.754C90.0463 139.281 90.4753 138.929 91.1463 138.929C91.6963 138.929 92.3013 139.138 92.8293 139.479L93.2143 138.841C92.6313 138.456 91.8613 138.214 91.1683 138.214C90.0463 138.214 89.2323 138.863 89.2323 139.842V139.864C89.2323 140.909 90.2223 141.217 91.1133 141.47C91.8613 141.679 92.5323 141.899 92.5323 142.471V142.493C92.5323 143.043 92.0373 143.395 91.3553 143.395C90.6843 143.395 90.0023 143.131 89.3863 142.669L88.9573 143.274C89.5953 143.791 90.4973 144.11 91.3113 144.11ZM94.9089 144H95.7559V142.515L96.9109 141.349L98.9459 144H99.9579L97.4939 140.755L99.8809 138.313H98.8249L95.7559 141.514V135.97H94.9089V144Z",
    fill: "#877ADD"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2746_11494",
    x: 24.4746,
    y: 48.8008,
    width: 89.0977,
    height: 48.1836,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "effect1_foregroundBlur_2746_11494"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2746_11494",
    x1: 355820,
    y1: 26958.5,
    x2: 355816,
    y2: 31405.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A3C9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2746_11494",
    x1: 40.9175,
    y1: 82.8556,
    x2: 43.7311,
    y2: 134.331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F338C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272054",
    stopOpacity: 0
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMetamaskConnect, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/metamask-connect.9cb96db4.svg";
export { ForwardRef as ReactComponent };